import { z } from "zod";

export const StringValueSchema = z.string();
